/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SessionRestrictionContextParser = 
/* #__PURE__ */ parsers.object([
    ['courseId', codecNumber, 'course_id'],
    ['isolated', /* #__PURE__ */ codecOptional(codecBoolean)],
]);
export class SessionRestrictionContext extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SessionRestrictionContextParser.decode(input).map(res => new SessionRestrictionContext(res));
    }
    static unsafeDecode(input) {
        return SessionRestrictionContext.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SessionRestrictionContextParser.encode(data);
    }
    static schema() {
        return SessionRestrictionContextParser.schema();
    }
}
